export default {
  init() {
    // JavaScript to be fired on all pages
    var backToTopEls = document.querySelectorAll('.scrollToTop');

    backToTopEls.forEach(element => {

      element.addEventListener('click', e => {

        e.preventDefault();
  
        window.scroll({
          top: 0,
          behavior: 'smooth'
        });
      });
    });

    var trigger = document.querySelectorAll('.nav-mobile__trigger');

    trigger[0].addEventListener('click', e => {
      document.body.classList.toggle('menu-open');
    });

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js